/* eslint-disable react/jsx-props-no-spreading */
import { Avatar, Form, Select } from 'antd';
import _ from 'lodash';
import React from 'react';
import './index.scss';

export default React.forwardRef((props, ref) => {
  const {
    options = [],
    variant = '',
    label,
    itemClassName,
    className,
    fullWidth = true,
  } = props;
  const itemProps = _.pick(props, [
    'label',
    'help',
    'validateStatus',
    'tooltip',
    'rules',
    'name',
  ]);
  const selectProps = _.pick(props, [
    'onSelect',
    'placeholder',
    'onDeselect',
    'onChange',
    'value',
    'notFoundContent',
    'dropdownRender',
    'getInputElement',
    'disabled',
    'mode',
    'allowClear',
    'filterOption',
    'showSearch',
    'onBlur',
  ]);

  const selectComponent = (
    <Select
      {...selectProps}
      ref={ref}
      className={`zorba-select ${variant || ''} ${className || ''} ${
        fullWidth ? 'full-width' : ''
      }`}
      optionLabelProp="label"
      {...(props.field || {})}
    >
      {props.children ||
        options.map((option) => (
          <Select.Option
            key={option.value}
            value={option.value}
            label={option.label || option.text}
          >
            {option.image && (
              <Avatar role="img" src={option.image} alt={option.text} />
            )}
            {option.label || option.text}
          </Select.Option>
        ))}
    </Select>
  );

  return label ? (
    <Form.Item
      {...itemProps}
      className={`zorba-select-item ${variant || ''} ${itemClassName || ''} ${
        fullWidth ? 'full-width' : ''
      }`}
    >
      {selectComponent}
    </Form.Item>
  ) : (
    selectComponent
  );
});
